import { render, staticRenderFns } from "./project_export.vue?vue&type=template&id=4d8284cd&scoped=true&"
import script from "./project_export.vue?vue&type=script&lang=js&"
export * from "./project_export.vue?vue&type=script&lang=js&"
import style0 from "./project_export.vue?vue&type=style&index=0&id=4d8284cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8284cd",
  null
  
)

/* custom blocks */
import block0 from "./project_export.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports